import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import _ from 'lodash'

import Head from 'next/head'

import handleContentBlocks from "../../lib/content-blocks"
import handleSeomaticMeta from "../../lib/seomatic"
import { 
    QueryPageHeader,
	QueryText, 
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
    QueryProfileCarousel,
    QuerySEO,
    QueryImages,
	QueryOffsetCallout,
	QueryCards,
	QuerySpacer,
	QueryProfileGroups,
	BizzaboSpeakers,
	BizzaboPartners
} from "../../graphql/queries"

import { HeaderShim } from '../../fuselage/global/header/header'
import { SectionCorner } from "../../fuselage/theme/2024/section-corners/section-corners"

function Speakers({ seomatic, bizzaboSpeakers, contentBlocks }) {

	// console.log('contentBlocks:', contentBlocks)
	// console.log('CMS-speakers:', contentBlocks[3]?.speakerProfileGroups[0].profiles)
	// console.log('bizzabo speakers found:', bizzaboSpeakers.length)
	// console.log('bizzabo speaker data:', bizzaboSpeakers)


	return (
		<>

			{/* <Head>
				{ handleSeomaticMeta( seomatic ) }  
            </Head> */}

			<HeaderShim />

			{ handleContentBlocks( contentBlocks, bizzaboSpeakers, null ) }

		</>
	)
}

Speakers.theme = 're-2024'



export async function getStaticProps() {

	const bizzaboSpeakers = await fetch(`https://api.bizzabo.com/api/speakers?eventId=${process.env.BIZZABO_EVENT_ID}&size=200`, {
		"method": "GET",
		"headers": {
			"Content-Type": "application/json",
			"Authorization": "Bearer 67f61f9e-e897-4536-914e-3f47286650f9"
		}
	})
	const json = await bizzaboSpeakers.json()


	const cmsData = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", id: "89843") {
					... on ${process.env.SITE_HANDLE}Speakers_${process.env.SITE_HANDLE}Speakers_Entry {
						id
						title
						slug
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryPageHeader}
							${QueryText} 
							${QueryFlipFlops} 
							${QueryFloaters} 
							${QueryBillboards} 
							${QueryBillboardSliders} 
							${QueryImpactFigures} 
							${QueryVideos}
							${QueryForm}
							${QueryProfileCarousel}
							${QuerySEO}
							${QueryImages}
							${QueryOffsetCallout}
							${QueryCards}
							${QuerySpacer}
							${QueryProfileGroups}
						}
						${QuerySEO}
					}
				}
			}
        `
    })

	// console.log('cmsData:', cmsData)

	return {
		props: { 
			seomatic: cmsData.data.entry.seomatic,
			contentBlocks: cmsData.data.entry.aviadevRealEstateContentBlocks,
		}
	}
}

export default Speakers


